import { maskPhoneByCountry } from './masks';

export function formatPerformanceSupportPhone(
  countryCode: string | null | undefined,
  phoneNumber: string | null | undefined,
): string | null {
  const digits = (phoneNumber ?? '').replace(/\D/g, '');
  if (!digits) {
    return null;
  }

  const code = (countryCode ?? '').replace(/\D/g, '') || '55';
  const masked = maskPhoneByCountry(digits, code);
  return code === '55' ? masked : `+${code} ${masked}`;
}
